function moveCurrencySymbol() {
  
    let priceElements = document.querySelectorAll('.price-value p');

    console.log(priceElements);

    priceElements.forEach(function(priceElement){
      let priceText = priceElement.textContent.trim();

      let priceValue = priceText.replace('€', '').trim();
    
      priceElement.textContent = priceValue + ' €';
    })
  
    
}

moveCurrencySymbol();